import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';
import {Practice} from '../models/Practice';
import {map} from 'rxjs/operators';
import {EnvironmentService} from '../services/environment.service';
import {HttpClient} from '@angular/common/http';
import { PmsAppointmentType } from '../interfaces/pms-appointment-types.interface';
import { PmsAppointmentTypesAdapter } from '../adapters/pms-appointment-types.adapter';
import { PmsClipbpards } from '../interfaces/pms-clipboards.interface';
import { PmsClipbpardsDto } from '../interfaces/pms-clipboard.dto';
import { PmsClipboardsAdapter } from '../adapters/pms-clipboards.adapter';

@Injectable({
  providedIn: 'root'
})
export class PracticesService {

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private adapter: PmsAppointmentTypesAdapter,
    private clipboardsAdapter: PmsClipboardsAdapter
  ) { }

  getAppointmentTypes(practice: Practice | null): Observable<PmsAppointmentType[]> {
    if (!practice) {
      return of([]);
    }

    const url = this.environmentService.get('backendUrl') + `/practices/${practice.id}/pms-appointment-types`;

    return this.http.get<PmsAppointmentType[]>(url, {
      withCredentials: true,
    }).pipe(
      map((response: PmsAppointmentType[]) => {
        return response.map(p => this.adapter.run(p));
      })
    );
  }

  getClipboards(practice: Practice | null): Observable<PmsClipbpards[]> {
    if (!practice) {
      return of([]);
    }

    const url = this.environmentService.get('backendUrl') + `/practices/${practice.id}/pms-clipboards`;

    return this.http.get<PmsClipbpardsDto[]>(url, {
      withCredentials: true,
    }).pipe(
      map((clipboards: PmsClipbpards[]) => {
        const uniqueClipboards = Array.from(
          new Map(clipboards.map(cb => [cb.clipboardCode, cb])).values()
        );
        return uniqueClipboards.map(p => this.clipboardsAdapter.run(p));
      })
    );
  }
}
